
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class HelperModal extends Vue {
  public show: boolean = false
}
